export default "__VITE_ASSET__BYwSA0Vo__"